import {
    axiosApi
} from "./api"
export const chainIndex = {
    //环比
    chain: (compareType, dateRange, paramType, value) => {
        return axiosApi("get", "/power/compare")({
            compareType,
            dateRange,
            paramType,
            value
        })
    },
    //同比
    chainyear: (compareType, current, dateRange, paramType, value) => {
        return axiosApi("get", "/power/compare")({
            compareType,
            current,
            dateRange,
            paramType,
            value
        })
    },
    chainData: (compareType, dateRange, paramType, value) => {
        return axiosApi("get", "/power/compare/data")({
            compareType,
            dateRange,
            paramType,
            value
        })
    },
    //获取项目所有区域
    site: (projectId) => {
        return axiosApi("get", "/area/project/all")({
            projectId
        })
    },
    soso: (name, projectId) => {
        return axiosApi("get", "/area/name/like")({
            name,
            projectId
        })
    },
    getData: (projectId) => {
        return axiosApi("get", "/project/info")({
            projectId
        })
    },
    bianyaqiAll:(projectId) =>{
        return axiosApi("get", "/device/transformer/capacity/project")({
            projectId
        })
    },
    bianyaqiSite:(projectId) =>{
        return axiosApi("get", "/device/transformer/capacity/area")({
            projectId
        })
    },
    //获取项目所有回路
    totalAll: (projectId) => {
        return axiosApi("get", "/loop/all")({
            projectId
        })
    },
    //首页事件描述
    arr: (page, projectId, size) => {
        return axiosApi("get", "/alarm/details/infos")({
            page,
            projectId,
            size
        })
    },
    //获取项目报警分类数量
    warnAll: (d, projectId) => {
        return axiosApi("get", "/alarm/num/day")({
            d,
            projectId
        })
    },
    //请求订阅mqqt主题
    mqqtAll: (areaId) => {
        return axiosApi("get", "/loop/master/area")({
            areaId
        })
    },
    loopAll: (projectId) => {
        return axiosApi("get", "/loop/master")({
            projectId
        })
    },
    monitoring: (projectId) => {
        return axiosApi("get", "/diagram/wiring/tree")({
            projectId
        })
    },
    //获取3DURL
    therrD: (projectId) => {
        return axiosApi("get", "/project/info")({
            projectId
        })
    },
    //根据分类查询项目中的设备
    transformer: (classId, projectId) => {
        return axiosApi("get", "/device/project/class")({
            classId,
            projectId
        })
    },
    //进线断路器
    breaker: (areaId) => {
        return axiosApi("get", "/area/device/loop/inletLineStatus")({
            areaId
        })
    },

    barkerAll(projectId) {
        return axiosApi("get", "/loop/master")({
            projectId
        })
    },
    //根据区域获取树形结构设备信息
    firmIdInfo: (areaId) => {
        return axiosApi("get", "/device/tree/area")({
            areaId
        })
    },
    //根据区域获取负荷率
    load: (projectId) => {
        return axiosApi("get", "/diagram/influxdb/data/load")({
            projectId
        })
    },
    //查询项目所有设备网关
    gateway: (projectId) => {
        return axiosApi("get", "/device/project/all")({
            projectId
        })
    },
    //根据区域查询变压器
    transformerId: (areaId) => {
        return axiosApi("get", "/device/transformer/list")({
            areaId
        })
    },

    //根据区域查询查询设备数量

    QueryFacility: (areaId) => {
        return axiosApi("get", "/device/area/class/number")({
            areaId
        })
    },
    floor:(projectId) => {
        return axiosApi("get", "/diagram/wiring/floor")({
            projectId
        })
    },
    cameraFloor:(projectId) => {
        return axiosApi("get", "/device/project/floor")({
            projectId
        })
    },
}